import {Button} from "../../Form/Button/Button";
import {buttonColors} from "../../Pickers/InputTheme";
import {Modal} from "../Modal/Modal";
import React, {useContext} from "react";
import './confirmationModal.scss'
import {I18nReactContext} from "../../../contexts/I18nContext";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";

export const ConfirmationModal = ({
                                      confirmationModalOpen,
                                      onCloseConfirmationModal,
                                      title,
                                      message,
                                      onConfirm,
                                      onCancel,
                                      confirmText,
                                      cancelText,
                                      messageBody,
                                      isLoading = false,
                                      hideCancelButton = false,
                                      destructive = false
                                  }) => {
    const {i18n} = useContext(I18nReactContext);
    // Destructive flips the standard cancel/confirm color emphasis so the destructive
    // action reads as primary (brand yellow) and Cancel sits back as the safer secondary choice.
    const cancelColor = destructive ? buttonColors.GREY : buttonColors.YELLOW;
    const confirmColor = destructive ? buttonColors.YELLOW : buttonColors.GREY;
    return <Modal
        open={confirmationModalOpen}
        onClose={onCloseConfirmationModal}>
        <div className="ConfirmationModal modalWrapper">
            {isLoading && <LoadingSpinner />}
            <div className="modalTitle">
                <div>{title}</div>
            </div>
            <div className="modalContent">
                <div className="message">{message}</div>
                {messageBody ? <div className="messageBody">
                    {messageBody}
                </div> : ''}
            </div>
            <div className="modalFooter">
                {!hideCancelButton && (
                    <Button
                        color={cancelColor}
                        onClick={onCancel}
                        text={cancelText || i18n.translate('confirmationModal.cancel')}
                        disabled={isLoading}
                    />
                )}
                <Button
                    color={confirmColor}
                    onClick={onConfirm}
                    text={confirmText || i18n.translate('confirmationModal.confirm')}
                    disabled={isLoading}
                />
            </div>
        </div>
    </Modal>
}